/*!
 * @Author: leo
 * @Date: 2019-12-25 20:55:00
 * @Last Modified by: leo
 * @Last Modified time: 2019-12-25 20:55:00
 * @Instruduction: 首页服务接口
 */

import xhr from './xhr/index'

class HomeService {
    /** 获取首页统计数据 */
    public async getHomeStat() {
        const result = await xhr({
            method: 'get',
            url: '/home/stat',
            params: null 
        })
        return result
    }
}

// 实例化后导出，全局单例
export default new HomeService()
